import React from 'react';
import { useGetPermissions } from 'layouts/customHook';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import ParentFeedbackConfigPage from './ParentFeedbackConfigPage';

const ParentFeedbackConfigSetup = () => {
    const userPermissions = useGetPermissions('parentFeedbackCollectionConfig');

    return (
        userPermissions ? <ParentFeedbackConfigPage userPermissions={userPermissions} /> : <PermisionDenied />
    )
}

export default ParentFeedbackConfigSetup;